import React from 'react';
import { Button } from 'antd';

import ItemsListToolbar from './ItemsListToolbar';
import ItemsDisplayMenu from './ItemsDisplayMenu';

/**
 * THE COLLECTION ITEMS PAGE'S TOOLBAR (KPR-1633, KPE-051 ruling i01): where
 * each control the page builds goes. Two rows, one job each:
 *
 *   view   Saved filter ▾ · card · sub-collection · scope · search
 *                                  … count · refresh · view switch · board · Display ▾
 *   query  + Filter · review · applied chips · worklist chips · quick filters ·
 *          Include linked · Sort                  … Clear · Update / Save as new / Revert
 *
 * The first row says what you are looking at, the second how it is narrowed
 * and ordered. How the list is DRAWN (group, columns, tile, row density) is
 * behind Display ▾ (ItemsDisplayMenu). The saved filter menu leads row 1 and
 * names the filter you are in (KPR-1642); the end of the query row is the
 * commit slot (`data-toolbar-commit`): Clear, then the saved filter's
 * Update "…" · Save as new · Revert while it has changed, or Save filter
 * (components/items/SavedFilterCommit).
 *
 * On a phone nothing scrolls sideways: Saved filter ▾ and the card, then
 * search, then the rows that apply (sub-collection, board, scope, Include
 * linked), then + Filter · Sort · count · refresh · ⋯ (the view switch and
 * Display) · Clear, then the saved filter's buttons on a row of their own,
 * then the chips.
 *
 * `c` is the page's controls, each a node or null where it does not apply;
 * `display` is ItemsDisplayMenu's props. Nothing here fetches or keeps state.
 */
export default function CollectionItemsToolbar({ isMobile = false, c, display, onClearFilter }) {
	const clear = c.hasQuery && onClearFilter ? (
		<Button type="link" className="items-page__clear-filter" onClick={onClearFilter}>Clear</Button>
	) : null;
	const commit = <span className="items-page__toolbar-commit" data-toolbar-commit>{clear}{c.savedFilterCommit}</span>;
	const chips = (
		<>
			{c.reviewControl}
			{c.filterChips}
			{c.worklistChips}
			{c.quickFilters}
		</>
	);

	if (isMobile) {
		const anyChips = Boolean(c.reviewControl || c.filterChips || c.worklistChips || c.quickFilters);
		return (
			<ItemsListToolbar
				stacked
				search={c.searchBox}
				primary={(
					<>
						{c.savedFilters}
						{c.cardFilterSelect}
					</>
				)}
				rows={[ c.subCollectionSelect, c.boardControls, c.scopeSwitch, c.linkedToggle ]}
				commit={c.savedFilterCommit}
				secondary={(
					<>
						{c.filterBuilder}
						{c.sortSelect}
						{c.countLabel}
						{c.refreshButton}
						<ItemsDisplayMenu {...display} isMobile lead={c.viewSwitch} />
						{clear}
					</>
				)}
				chips={anyChips ? chips : null}
			/>
		);
	}

	return (
		<ItemsListToolbar
			view={{
				start: (
					<>
						{c.savedFilters}
						{c.cardFilterSelect}
						{c.subCollectionSelect}
						{c.scopeSwitch}
						{c.searchBox}
					</>
				),
				end: (
					<>
						{c.countLabel}
						{c.refreshButton}
						{c.viewSwitch}
						{c.boardControls}
						<ItemsDisplayMenu {...display} />
					</>
				),
			}}
			query={{
				start: (
					<>
						{c.filterBuilder}
						{chips}
						{c.linkedToggle}
						{c.sortSelect}
					</>
				),
				end: commit,
			}}
		/>
	);
}
